// extracted by mini-css-extract-plugin
module.exports = {"link-zoom-text":"styles__link-zoom-text___mlRzg","footer":"styles__footer___172MV","link":"styles__link___1EGU7"};